const AppNameAsLogo = () => {
  return (
    <a href="/">
      <h1 className="text-xl font-semibold text-gray-800">
        Ask<span className="text-green-500">-The-</span>Bill
      </h1>
    </a>
  );
};

export default AppNameAsLogo;
